import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";

import { fetchPut } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";

import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";
import CustomInput from "../../Common/CustomInput";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  buttonIcon: {
    boxShadow: `0px 1px 2px 0px ${colors.black24}, 0px 1px 3px 0px ${colors.black12}`,
    padding: "0px !important",
    minWidth: "0px",
    "& img": {
      width: "32px",
    },
  },
  closeIcon: {
    display: "flex",
    justifyContent: "flex-end",
  },
};

const AddComment = (props) => {
  const { classes, open, onOpen, onClose, dacId } = props;
  const [comment, setComment] = React.useState("");

  const submit = async () => {
    if (dacId) {
      try {
        await fetchPut(`event_groups/${dacId}`, {
          description: comment,
        });
        setComment("");
        onClose();
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <>
      <Button onClick={onOpen} className={classes.buttonIcon}>
        <img
          src={images.commentsIconColored}
          style={{ display: "block" }}
          alt="comments"
        />
      </Button>
      <Dialog open={open} fullWidth>
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ height: "100%", padding: "24px" }}
        >
          <Grid item style={{ marginBottom: "20px" }}>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="dialogTitle">
                {I18n.get("site_addComment").toUpperCase()}
              </Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={onClose} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <CustomInput
              name="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              multiline={true}
              height="200px"
            />
          </Grid>
          <Grid item style={{ marginTop: "20px" }}>
            <Grid container justify="center">
              <Grid item style={{ margin: "0px 10px" }}>
                <CustomButton color="primary" onClick={onClose}>
                  {I18n.get("site_cancel")}
                </CustomButton>
              </Grid>
              <Grid item style={{ margin: "0px 10px" }}>
                <CustomButton
                  variant="contained"
                  color="primary"
                  onClick={submit}
                >
                  {I18n.get("site_save")}
                </CustomButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

AddComment.propTypes = {
  dacId: PropTypes.number,
};

export default withStyles(styles)(AddComment);
